import React from "react";
import { Table, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom, faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";

const CategoriesList = ({ workspaceId, categories, reload, refresh, refreshProducts, onEdit }) => {
  const handleClearProducts = async (id) => {
    if (!window.confirm("Xoá toàn bộ sản phẩm trong category này?")) return;
    try {
      const res = await Utils._apiRequest({
        path: Enums.endpoints.products.CATEGORY_CLEAR_PRODUCTS,
        pathParams: { id },
        type: "DELETE",
      });
      if (res.errors) throw new Error(res.errors);
      toast.success(`Đã xoá ${res.deletedCount || 0} sản phẩm khỏi category`);
      refresh && refresh();
      refreshProducts && refreshProducts();
    } catch (err) {
      toast.error(err.message || "Lỗi khi xoá sản phẩm");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Xoá category này? Các sản phẩm sẽ bị bỏ khỏi category (không xoá sản phẩm).")) return;
    try {
      const res = await Utils._apiRequest({
        path: Enums.endpoints.products.CATEGORY_DETAIL,
        pathParams: { id },
        type: "DELETE",
      });
      if (res.errors) throw new Error(res.errors);
      toast.success("Đã xoá category");
      refresh && refresh();
      refreshProducts && refreshProducts();
    } catch (err) {
      toast.error(err.message || "Lỗi khi xoá");
    }
  };

  return (
    <Table striped hover responsive>
      <thead>
        <tr>
          <th style={{ width: 20 }}>#</th>
          <th>Tên</th>
          <th>Slug</th>
          <th>Mô tả</th>
          <th style={{ width: 120 }}>Sản phẩm</th>
          <th style={{ width: 130 }} className="text-end">Thao tác</th>
        </tr>
      </thead>
      <tbody>
        {!categories.length ? (
          <tr>
            <td colSpan={6} className="text-center text-muted py-4">
              Chưa có category nào.
            </td>
          </tr>
        ) : (
          categories.map((c, idx) => (
            <tr key={c._id}>
              <td>{idx + 1}</td>
              <td className="fw-medium">{c.name}</td>
              <td className="text-muted">{c.slug || "--"}</td>
              <td className="text-muted">{c.description || "--"}</td>
              <td>{c.productCount || 0}</td>
              <td className="text-end">
                <Button
                  variant="outline-warning"
                  size="sm"
                  className="me-1"
                  onClick={() => handleClearProducts(c._id)}
                  title="Xoá toàn bộ sản phẩm trong category"
                >
                  <FontAwesomeIcon icon={faBroom} />
                </Button>
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="me-1"
                  onClick={() => onEdit(c)}
                >
                  <FontAwesomeIcon icon={faPenToSquare} />
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleDelete(c._id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default CategoriesList;
